import React from 'react';
import { Document, Page } from 'react-pdf';
import { Box, CircularProgress } from '@mui/material';

interface PDFThumbnailProps {
  file: File | string;
  width?: number;
}

/**
 * A React component for rendering PDF thumbnails using react-pdf
 */
const PDFThumbnail: React.FC<PDFThumbnailProps> = ({ file, width = 100 }) => {
  return (
    <Box 
      sx={{ 
        width: width, 
        height: (width * 1.4), 
        border: '1px solid #ddd',
        borderRadius: '4px',
        overflow: 'hidden',
        '& .react-pdf__Page': {
          // Override the default height to ensure thumbnail fits properly
          '& canvas': {
            width: '100% !important',
            height: 'auto !important',
          }
        }
      }}
    >
      {/* Wrap Document in a div to avoid nested button issues */}
      <div>
        <Document
          file={file}
          loading={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress size={20} />
            </Box>
          }
          error={
            <Box sx={{ 
              background: '#f40f02', 
              height: '100%', 
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center',
              color: 'white',
              fontSize: '12px',
              padding: '5px'
            }}>
              <div>PDF</div>
              {file instanceof File && 
                <div style={{ fontSize: '8px', marginTop: '5px' }}>{file.name}</div>
              }
            </Box>
          }
          noData={
            <Box sx={{ 
              background: '#f40f02', 
              height: '100%', 
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center',
              color: 'white',
              fontSize: '12px'
            }}>
              <div>PDF</div>
            </Box>
          }
        >
          <Page 
            pageNumber={1} 
            width={width}
            height={width * 1.4}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    </Box>
  );
};

export default PDFThumbnail;